import { useState } from 'react'
import type { SavedDocument } from '@creanizer/types'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@creanizer/ui'
import { Button, Input, Textarea, Label } from '@creanizer/ui'

interface DocumentEditModalProps {
  isOpen: boolean
  onClose: () => void
  onSave: (document: Partial<SavedDocument>) => void
  document: SavedDocument
}

export function DocumentEditModal({ isOpen, onClose, onSave, document }: DocumentEditModalProps) {
  const [title, setTitle] = useState(document.title)
  const [memo, setMemo] = useState(document.memo || '')
  const [tags, setTags] = useState((document.tags || []).join(', '))
  
  const handleSave = () => {
    onSave({
      title,
      memo: memo || undefined,
      tags: tags ? tags.split(',').map(tag => tag.trim()).filter(Boolean) : undefined
    })
  }
  
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>文献を編集</DialogTitle>
          <DialogDescription>
            保存済みの文献の情報を編集します
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 mt-4">
          <div>
            <Label htmlFor="title">タイトル</Label>
            <Input
              id="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="文献のタイトル"
            />
          </div>
          
          <div>
            <Label htmlFor="memo">メモ</Label>
            <Textarea
              id="memo"
              value={memo}
              onChange={(e) => setMemo(e.target.value)}
              placeholder="この文献に関するメモ"
              rows={3}
            />
          </div>
          
          <div>
            <Label htmlFor="tags">タグ（カンマ区切り）</Label>
            <Input
              id="tags"
              value={tags}
              onChange={(e) => setTags(e.target.value)}
              placeholder="タグ1, タグ2, タグ3"
            />
          </div>
          
          <div className="bg-gray-50 p-4 rounded-lg">
            <h4 className="font-medium mb-2">文献情報</h4>
            <div className="text-sm space-y-1 text-gray-600">
              <div>タイプ: {document.result.type}</div>
              <div>作成日: {new Date(document.createdAt).toLocaleString('ja-JP')}</div>
              {document.updatedAt && (
                <div>更新日: {new Date(document.updatedAt).toLocaleString('ja-JP')}</div>
              )}
              {document.worldId && <div>世界観連携: あり</div>}
              {document.characterIds && document.characterIds.length > 0 && (
                <div>キャラクター連携: {document.characterIds.length}件</div>
              )}
            </div>
          </div>
        </div>
        
        <div className="flex justify-end gap-2 mt-6">
          <Button variant="outline" onClick={onClose}>
            キャンセル
          </Button>
          <Button onClick={handleSave}>
            保存
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}